module.exports = __webpack_public_path__ + "img/blog-banner.d434fbfe.png";